module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./PlanView.js"));
	}, "MyPlanView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MyPlanView!./src/pages/Learn/My/Plan/PlanView.js
// module id = 2214
// module chunks = 367